import React from "react";
import SidebarComponent from "./components/SidebarComponent";
import { Outlet, useLocation } from "react-router-dom";
import Spinner from "../shared/components/Spinner";
import { useSelector } from "react-redux";
import { selectLoaderValue } from "../../redux/Slices/loadingSlice";
import ProfileSidebarComponent from "./components/ProfileSidebarComponent";
import MyProfileSidebarComponent from "./components/MyProfileSidebarComponent";

const ClientLayout = () => {
    const location = useLocation();
    const isLoading = useSelector(selectLoaderValue);
    const getSideBarComponent = () => {
        if (location.pathname === "/clients/profilesettings") {
            return (<></>);
        }
        else if (location.pathname === "/clients/profile") {
            return (<MyProfileSidebarComponent />);
        }
        return (<SidebarComponent />);
    };
    return (
        <Outlet />
        // <div className="min-h-screen bg-gray-50" style={{ textAlign: "left" }}>
        //     {isLoading && (
        //         <div className="fixed left-[50%] top-[50%] z-[1000px]">
        //             <Spinner color="green" />
        //         </div>
        //     )}
        //     <SharedHeader5 />
        //     <div className={`flex min-h-screen  ${isLoading ? "opacity-25" : "opacity-100"}`}>
        //         {getSideBarComponent()}

        //         <div className={`flex-1 w-full ${location.pathname === "/clients/profile" || location.pathname === "/clients/profilesettings" ? "" : "lg:pl-64"}`}>
        //             <main
        //                 className={`flex-1  ${location.pathname === "/clients/profile" ? " lg:pl-64 w-full profile-content" : "p-4"}`}
        //                 style={{ textAlign: "left" }}
        //             >
        //                 <Outlet />
        //             </main>
        //         </div>

        //     </div>
        // </div >
    );
};

export default ClientLayout;